import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {lastValueFrom} from 'rxjs';
import {LearnerPointsResponseDto} from '../../types/LearnerPointsResponseDto';
import {LearnerRankingResponseDto} from '../../types/LearnerRankingResponseDto';
import {EnvironmentService} from '../EnvironmentService';
import {ShowRankingOrganizationFeatureState} from '../ShowRankingOrganizationFeatureState';

@Injectable({
    providedIn: 'root'
})
export class ScoreboardRessource {

    constructor(private http: HttpClient, private environmentService: EnvironmentService) {
    }

    public async getLearnerPoints(msteamsId: string): Promise<LearnerPointsResponseDto> {
        return lastValueFrom(this.http.get<LearnerPointsResponseDto>(`${this.environmentService.environment.serverUrl}/api/profile/scoreboard/points`, {params: {msteamsid: msteamsId}}));
    }

    public async getLearnerPointsForLearn(learnerId?: string): Promise<LearnerPointsResponseDto> {
        const options = learnerId !== undefined ? {params: {learnerid: learnerId}} : undefined;
        return lastValueFrom(this.http.get<LearnerPointsResponseDto>(`${this.environmentService.environment.serverUrl}/api/learn/profile/scoreboard/points`, options));
    }

    public async getRankingActivatedStatus(msteamsId: string): Promise<{rankingActiveState: ShowRankingOrganizationFeatureState}> {
        return lastValueFrom(this.http.get<{rankingActiveState: ShowRankingOrganizationFeatureState}>(`${this.environmentService.environment.serverUrl}/api/profile/scoreboard/is-ranking-active`, {params: {msteamsid: msteamsId}}));
    }

    public async getRankingActivatedStatusForLearn(learnerId?: string): Promise<{rankingActiveState: ShowRankingOrganizationFeatureState}> {
        const options = learnerId !== undefined ? {params: {learnerid: learnerId}} : undefined;
        return lastValueFrom(this.http.get<{rankingActiveState: ShowRankingOrganizationFeatureState}>(`${this.environmentService.environment.serverUrl}/api/learn/profile/scoreboard/is-ranking-active`, options));
    }

    // The backend sends an empty body when the organization has no ranking for the period, which HttpClient parses as null.
    public async getScoreboard(msteamsId: string, period: string, date: string): Promise<LearnerRankingResponseDto | undefined> {
        const scoreboard = await lastValueFrom(this.http.get<LearnerRankingResponseDto | null>(`${this.environmentService.environment.serverUrl}/api/profile/scoreboard/ranking`,
            {params: {period: period, date: date, msteamsid: msteamsId}}));
        return scoreboard ?? undefined;
    }

    public async getScoreboardForLearn(period: string, date: string, learnerId?: string): Promise<LearnerRankingResponseDto | undefined> {
        const options: {params: {period: string, date: string, learnerid?: string[]}} = {params: {period: period, date: date}};
        if (learnerId !== undefined) {
            options.params.learnerid = [learnerId];
        }
        const scoreboard = await lastValueFrom(this.http.get<LearnerRankingResponseDto | null>(`${this.environmentService.environment.serverUrl}/api/learn/profile/scoreboard/ranking`, options));
        return scoreboard ?? undefined;
    }
}
